export const internshipPrograms = [
  {
    id: 'fullstack-web-2024',
    title: 'Full Stack Web Development',
    shortDesc: 'Build production-ready web apps from scratch',
    batch: 'Batch 2 · 2024',
    duration: '3 Months',
    studentsCount: 14,
    level: 'Intermediate',
    color: 'from-blue-500 to-blue-700',
    iconBg: 'bg-blue-500',
    skills: ['React.js', 'Node.js', 'MongoDB', 'Firebase', 'Tailwind CSS'],
    highlights: ['Real client projects', 'Industry mentors', 'Certificate', 'Job assistance'],
    coverImage: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=900&h=500&fit=crop&q=80',
    description: 'A hands-on 3-month program where interns build real full-stack web applications for actual clients. From frontend to backend, database design to deployment — you learn everything needed to ship production software.',
    milestones: [
      { week: 'Week 1–2', title: 'Orientation & Setup', description: 'Introduction to the CALLOC workflow, dev environment setup, Git/GitHub mastery, and project planning fundamentals.' },
      { week: 'Week 3–5', title: 'React Frontend', description: 'Component-driven architecture, React hooks, state management with Context API and Redux, responsive UI design.' },
      { week: 'Week 6–8', title: 'Node.js Backend', description: 'REST API design with Express.js, MongoDB database modeling, JWT authentication, and security best practices.' },
      { week: 'Week 9–10', title: 'Integration & Deployment', description: 'Full-stack integration, Firebase hosting, AWS deployment, CI/CD pipelines, and performance optimization.' },
      { week: 'Week 11–12', title: 'Capstone Project', description: 'Build and present a complete application for a real client. Code review, demo day, and final evaluation.' },
    ],
    photos: [
      { url: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=700&h=500&fit=crop&q=80', caption: 'Orientation Day' },
      { url: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=700&h=500&fit=crop&q=80', caption: 'Team Coding Session' },
      { url: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=700&h=500&fit=crop&q=80', caption: 'Project Review Meeting' },
      { url: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=700&h=500&fit=crop&q=80', caption: 'Pair Programming Workshop' },
      { url: 'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=700&h=500&fit=crop&q=80', caption: 'UI/UX Design Sprint' },
      { url: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=700&h=500&fit=crop&q=80', caption: 'Final Demo Day' },
    ],
    projects: [
      { name: 'E-Learning Portal', tech: ['React', 'Node.js', 'MongoDB'], description: 'A complete LMS with video courses, live classes, and assessments.' },
      { name: 'Inventory Management', tech: ['React', 'Express', 'PostgreSQL'], description: 'Real-time inventory tracking system for a local business.' },
      { name: 'Portfolio Builder', tech: ['Next.js', 'Firebase'], description: 'Drag-and-drop portfolio builder deployed for 200+ users.' },
    ],
    testimonials: [
      { name: 'Arjun K.', role: 'Now at TCS Digital', text: 'The internship gave me hands-on experience with real projects. I got placed within 3 weeks of completing the program. The mentors genuinely care about your growth.' },
      { name: 'Priya S.', role: 'Now at Infosys', text: 'Best learning experience of my life. The code reviews were brutal but that\'s exactly what made me a better developer. Highly recommend to anyone serious about web dev.' },
    ]
  },
  {
    id: 'mobile-app-2024',
    title: 'Mobile App Development',
    shortDesc: 'Ship cross-platform apps on iOS & Android',
    batch: 'Batch 1 · 2024',
    duration: '2 Months',
    studentsCount: 10,
    level: 'Intermediate',
    color: 'from-purple-500 to-purple-700',
    iconBg: 'bg-purple-500',
    skills: ['React Native', 'Expo', 'Firebase', 'Redux', 'Figma'],
    highlights: ['Publish to Play Store', 'UI/UX training', 'Certificate', 'Mentorship'],
    coverImage: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=900&h=500&fit=crop&q=80',
    description: 'An intensive 2-month program focused on building cross-platform mobile applications using React Native. Interns work on real apps published to the Google Play Store.',
    milestones: [
      { week: 'Week 1–2', title: 'Mobile Fundamentals', description: 'React Native architecture, Expo setup, navigation patterns, and mobile UI principles.' },
      { week: 'Week 3–4', title: 'UI Development', description: 'Figma to code translation, animations with Reanimated, responsive layouts for different screen sizes.' },
      { week: 'Week 5–6', title: 'State & APIs', description: 'Redux Toolkit, Firebase Firestore integration, push notifications, and background tasks.' },
      { week: 'Week 7–8', title: 'App Launch', description: 'Play Store deployment, app signing, performance profiling, crash reporting, and user feedback cycles.' },
    ],
    photos: [
      { url: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=700&h=500&fit=crop&q=80', caption: 'Mobile Dev Workshop' },
      { url: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=700&h=500&fit=crop&q=80', caption: 'UI Design Sprint' },
      { url: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=700&h=500&fit=crop&q=80', caption: 'App Testing Session' },
      { url: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=700&h=500&fit=crop&q=80', caption: 'Code Review' },
    ],
    projects: [
      { name: 'GK Academy App', tech: ['React Native', 'Firebase'], description: 'Learning app with 5,000+ downloads on Play Store.' },
      { name: 'Food Delivery UI', tech: ['React Native', 'Expo'], description: 'Full UI implementation of a restaurant ordering app.' },
    ],
    testimonials: [
      { name: 'Ravi M.', role: 'Freelance Developer', text: 'I published my first app to Play Store during this internship. That feeling is priceless. The guidance on app architecture really set me apart in interviews.' },
    ]
  },
  {
    id: 'ai-ml-2024',
    title: 'AI & Machine Learning',
    shortDesc: 'Build intelligent systems with real-world data',
    batch: 'Batch 1 · 2024',
    duration: '3 Months',
    studentsCount: 8,
    level: 'Advanced',
    color: 'from-rose-500 to-orange-500',
    iconBg: 'bg-rose-500',
    skills: ['Python', 'TensorFlow', 'scikit-learn', 'Pandas', 'FastAPI'],
    highlights: ['Real datasets', 'Model deployment', 'Research paper', 'Certificate'],
    coverImage: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=900&h=500&fit=crop&q=80',
    description: 'A research-oriented 3-month program for students passionate about AI. Interns work with real datasets, build and deploy ML models, and contribute to internal AI products.',
    milestones: [
      { week: 'Week 1–3', title: 'Python & Data Science', description: 'NumPy, Pandas, data cleaning, EDA, and visualization with Matplotlib/Seaborn.' },
      { week: 'Week 4–6', title: 'Machine Learning', description: 'Supervised/unsupervised learning, model evaluation, hyperparameter tuning with scikit-learn.' },
      { week: 'Week 7–9', title: 'Deep Learning', description: 'Neural networks with TensorFlow/Keras, CNNs, RNNs, transfer learning, and fine-tuning.' },
      { week: 'Week 10–12', title: 'Deployment & Research', description: 'Model deployment via FastAPI, writing a technical report, and presenting findings to the team.' },
    ],
    photos: [
      { url: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=700&h=500&fit=crop&q=80', caption: 'AI Research Session' },
      { url: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=700&h=500&fit=crop&q=80', caption: 'Data Analysis Workshop' },
      { url: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=700&h=500&fit=crop&q=80', caption: 'Model Training Lab' },
      { url: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=700&h=500&fit=crop&q=80', caption: 'Results Presentation' },
    ],
    projects: [
      { name: 'Exam Score Predictor', tech: ['Python', 'scikit-learn', 'FastAPI'], description: 'Predicts student performance with 89% accuracy.' },
      { name: 'Content Moderation AI', tech: ['TensorFlow', 'Python'], description: 'Image classifier deployed in a production app.' },
    ],
    testimonials: [
      { name: 'Sneha R.', role: 'Now at Wipro AI', text: 'Working with real datasets and actually deploying models changed my perspective. This isn\'t textbook ML — it\'s the real thing.' },
    ]
  },
  {
    id: 'cloud-devops-2024',
    title: 'Cloud & DevOps Engineering',
    shortDesc: 'Deploy, scale, and automate infrastructure',
    batch: 'Batch 1 · 2024',
    duration: '2 Months',
    studentsCount: 6,
    level: 'Advanced',
    color: 'from-teal-500 to-cyan-600',
    iconBg: 'bg-teal-500',
    skills: ['AWS', 'Docker', 'Kubernetes', 'CI/CD', 'Terraform'],
    highlights: ['AWS certification prep', 'Live infra projects', 'Certificate', 'Expert guidance'],
    coverImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=900&h=500&fit=crop&q=80',
    description: 'A practical 2-month DevOps internship where students set up and manage real cloud infrastructure on AWS. From containerization to CI/CD pipelines, you learn how modern software gets deployed at scale.',
    milestones: [
      { week: 'Week 1–2', title: 'Linux & Containers', description: 'Linux administration, Docker fundamentals, writing Dockerfiles, and managing multi-container apps.' },
      { week: 'Week 3–4', title: 'AWS Core Services', description: 'EC2, S3, RDS, Lambda, IAM, VPC, and cost optimization strategies.' },
      { week: 'Week 5–6', title: 'CI/CD & IaC', description: 'GitHub Actions pipelines, Terraform infrastructure-as-code, environment management.' },
      { week: 'Week 7–8', title: 'Kubernetes & Monitoring', description: 'K8s cluster management, auto-scaling, Prometheus/Grafana monitoring, and incident response.' },
    ],
    photos: [
      { url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=700&h=500&fit=crop&q=80', caption: 'Cloud Infrastructure Lab' },
      { url: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=700&h=500&fit=crop&q=80', caption: 'DevOps Workshop' },
      { url: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=700&h=500&fit=crop&q=80', caption: 'Pipeline Setup Session' },
      { url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=700&h=500&fit=crop&q=80', caption: 'System Architecture Review' },
    ],
    projects: [
      { name: 'Multi-env Deployment Pipeline', tech: ['GitHub Actions', 'AWS', 'Docker'], description: 'Full CI/CD pipeline for a 3-environment deployment.' },
      { name: 'Kubernetes Cluster Setup', tech: ['K8s', 'Terraform', 'AWS EKS'], description: 'Production-grade cluster with auto-scaling and monitoring.' },
    ],
    testimonials: [
      { name: 'Kiran D.', role: 'Cloud Engineer at Accenture', text: 'The hands-on AWS experience was invaluable. I came in knowing nothing about DevOps and left with a job offer. The real infrastructure projects make all the difference.' },
    ]
  },
];
